import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import { AppShell, type NavItem } from './AppShell';
import { UnitPickerDialog } from '../UnitPickerDialog';

export const SuperAdminLayout = () => {
  const [pickerOpen, setPickerOpen] = useState(false);

  const navItems: NavItem[] = [
    { label: 'Dashboard', to: '/superadmin', icon: <DashboardIcon />, exact: true },
    { label: 'Jednotky', to: '/superadmin/units', icon: <GroupsIcon /> },
    { label: 'Uživatelé', to: '/superadmin/users', icon: <PeopleIcon /> },
    { label: 'Soutěže (globálně)', to: '/superadmin/competitions', icon: <EmojiEventsIcon /> },
    { sectionLabel: 'Správa jednotek', icon: null, divider: true },
    {
      label: 'Přejít do administrace…',
      icon: <SupervisorAccountIcon />,
      onClick: () => setPickerOpen(true),
    },
    { sectionLabel: 'Systém', icon: null, divider: true },
    { label: 'Nastavení', to: '/superadmin/settings', icon: <SettingsIcon /> },
    { label: 'Viditelnost layoutů', to: '/superadmin/layout-visibility', icon: <ViewQuiltIcon /> },
  ];

  return (
    <AppShell navItems={navItems} title="SUPER ADMIN">
      <Outlet />
      <UnitPickerDialog open={pickerOpen} onClose={() => setPickerOpen(false)} targetPath="/admin" />
    </AppShell>
  );
};
